import { TFunction } from 'i18next';
import { ExtraBase } from '~/lib/api/smartsend/types';
import { ProtectionExtraIds, ExtendedBaseCoverExtra, ExtrasTitle } from '../../components/ExtrasHelper';
import { onlyUnique } from './ArrayHelper';
import { ToCommaList } from './StringHelper';
import { sanitiseKey } from '~/lib/utils/translation';

export function ToTranslatedExtra(t: TFunction<string, string>, extra: ExtraBase): string {
  return t(ToExtraTitleTranslationKey(extra), ExtrasTitle(extra));
}

export function ToUniqueExtras(t: TFunction<string, string>, extras: ExtraBase[]): string[] {
  const ids = extras.map((x) => x.Id);
  if (ProtectionExtraIds.filter((x) => ids.includes(x)).length === ProtectionExtraIds.length) {
    return extras
      .filter((x) => x.Id !== ExtendedBaseCoverExtra)
      .map((x) => ToTranslatedExtra(t, x))
      .filter(onlyUnique);
  } else {
    return extras.map((x) => ToTranslatedExtra(t, x)).filter(onlyUnique);
  }
}
export function ToUniqueExtrasList(t: TFunction<string, string>, extras: ExtraBase[]) {
  return ToCommaList(ToUniqueExtras(t, extras));
}
export const ToExtraDescriptionTranslationKey = (e: ExtraBase) => sanitiseKey(`EXTRA_${e.Id}_DESCRIPTION`);
export const ToExtraTitleTranslationKey = (e: ExtraBase) => sanitiseKey(`EXTRA_${e.Id}_TITLE`);
